var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m335.195 357.824-181.019-181.02c-6.185-6.185-6.185-16.442 0-22.627s16.442-6.185 22.627 0l181.02 181.02c6.185 6.185 6.185 16.442 0 22.628-6.185 6.185-16.443 6.185-22.628 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.177 357.824c-6.184-6.187-6.184-16.444 0-22.628l181.019-181.019c6.185-6.185 16.443-6.185 22.628 0s6.185 16.442 0 22.627l-181.02 181.02c-6.184 6.185-16.442 6.185-22.627 0"
  })));
};
export default SvgClose;